require('./cardTransferMoneyToCheckingAccountFeedbackSuccess.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CardTransferMoneyToCheckingAccountFeedbackSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.backToCards = this.backToCards.bind(this);
    }

    backToCards() {
        this.props.history.push('/myprofile/cards');
    }

    render() {
        const title = formatText('cardTransferMoneyToCheckingAccountFeedbackSuccess-title');
        const subtitle = formatText('cardTransferMoneyToCheckingAccountFeedbackSuccess-subtitle');
        const textLink = formatText('cardTransferMoneyToCheckingAccountFeedbackSuccess-backToCards');

        return (
            <div className="card-transfer-money-to-checking-account-feedback-success">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle={subtitle}
                    textLink={textLink}
                    goBackHandler={this.backToCards}
                />
            </div>
        );
    }
}

CardTransferMoneyToCheckingAccountFeedbackSuccess.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CardTransferMoneyToCheckingAccountFeedbackSuccess);
